import { displayDateFormatWithDay } from '@/constants/dates';
import { Box, Grid, Text } from '@cmpsr/components';
import { format } from 'date-fns';
import useTestingPlanController from '../your-testing-plan/your-testing-plan.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';

export default function TestingPlanHeader() {
  const { planStartDate, planEndDate } = useTestingPlanController();

  return (
    <DashboardLayout
      containerProps={{
        // Theses custom paddings are to have the main title
        // and subtitle at the same level in every page
        pt: { base: 4, md: 4, lg: 6 },
        pb: { base: 8, md: 10, lg: 14 },
        background: 'gradient.dark',
      }}
      contentProps={{ as: 'header', gap: 5 }}
    >
      <Text variant="text-body-meta-medium" textTransform="uppercase" color="tan">
        {format(new Date(planStartDate), displayDateFormatWithDay)} -{' '}
        {format(new Date(planEndDate), displayDateFormatWithDay)}
      </Text>

      <Grid gridTemplateColumns={{ base: 'auto', lg: '1fr 400px' }} gap={{ base: 8, lg: 8, xl: 9, xxl: 12 }}>
        <Box>
          <Text as="h1" variant="text-header-4XL" mb={2} data-testid="testing-plan-header-text" color="tan">
            Your Testing{' '}
            <Text as="span" textStyle="text-header-4xl-v" color="tan">
              Plan
            </Text>
          </Text>
          <Text variant="text-body-regular" fontSize={{ base: '14px', lg: '16px' }} color="tan">
            Your Annual Testing Plan represents the optimal screening tests to conduct over the next 12 months based on
            your current risk across all major cancers.
          </Text>
        </Box>
      </Grid>
    </DashboardLayout>
  );
}
